<div class="overlay-inner-wrapper overlay-fullscreen">
  <div id="inspektionWrapper">
    <header class="header-2">
      <div class="branding">
        <span class="title">{{ 'Begehung durchführen: ' | mrTranslate }}{{ ' ' + titel }}</span>
      </div>
      <div class="header-actions">
        <form clrForm [formGroup]="formGroup" style="width: 250px">
          <clr-date-container>
            <label>{{ 'Datum' | mrTranslate }}</label>
            <input
              id="dateInput"
              type="date"
              clrDate
              style="color: white"
              [ngModel]="dateControl | localeDate"
              (ngModelChange)="dateControl = localeDate.tosql($event)"
              [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
              [disabled]="formGroup.disabled"
              required />
            <clr-control-error *clrIfError="'required'"></clr-control-error>
          </clr-date-container>
        </form>

        <form clrForm [formGroup]="formGroup">
          <clr-input-container>
            <label>{{ 'Bemerkung' | mrTranslate }}</label>
            <input clrInput name="bemerkung" formControlName="bemerkung" style="width: 400px" />
          </clr-input-container>
        </form>

        <!-- style="margin-right: 120px ;" -->

        @if (showBeschreibungText() != '') {
          <a href="javascript://" class="nav-link nav-icon">
            <cds-icon
              shape="info-circle"
              style="width: 28px; height: 28px;"
              class="clickable"
              (click)="showInfo()">
            </cds-icon>
          </a>
        }


        <a href="javascript://" class="nav-link nav-icon">
          <cds-icon shape="window-close" (click)="close()"></cds-icon>
        </a>
      </div>
    </header>

    <div class="clr-row nxm" style="align-items: center">
      <div class="clr-col-auto margin-12-tb">
        <div class="btn-group btn-primary btn-icon">
          <button class="btn btn-icon" [title]="'Begehung speichern' | mrTranslate" (click)="saveBegehung()">
            <cds-icon shape="floppy" />
          </button>
          <button
            class="btn btn-icon btn-success"
            [title]="'Begehung für diese Objekt ist abgeschlossen' | mrTranslate"
            (click)="finishedBegehungObjekt()"
            [disabled]="ostammid == 0 || obegpid == 0">
            <cds-icon shape="check" />
          </button>
        </div>
      </div>
    </div>

    @if (objekttabelle?.rows?.length > 0) {
      <div class="clr-row nxm" style="padding-right: 10px">
        <div class="clr-col-md-6">
          <div class="clr-row nxm" style="padding-right: 10px">
            <div class="clr-col-md-8">
              <h4 style="margin-top: 2px">{{ 'Objekte' | mrTranslate }}</h4>
            </div>
            <div class="clr-col-md-4" style="margin-top: -8px; text-align: right">
              <!-- <ng-container *ngIf="lpid != 0"> -->
              <app-preview-thumbnails
                [drag_drop]="false"
                [hidden]="false"
                [onlyIcons]="true"
                [title]="'Passbild'"
                [maxAmount]="6"
                (deleteFile)="deleteBild($any($event))"
                (lastUpload)="setBildInForm($event)"
                [readonly]="lpid == 0"></app-preview-thumbnails>
              <!-- </ng-container> -->
            </div>
          </div>
          <div class="limit-height">
            @if (objekttabelle?.rows?.length > 0) {
              <clr-datagrid
                #objekteGrid
                class="datagrid-compact"
                [clrDgSelectionType]="'single'"
                [clrDgSelected]="[selectedObjekt]"
                (clrDgSelectedChange)="selectedObjekt = $event[0]; selectionGridChanged($event[0])"
                [clrDgRowSelection]="true">
                @for (column of objekttabelle.columns; track column) {
                  <clr-dg-column [clrDgField]="column.id" [style.min-width.px]="column.id.length * 7.5 + 26">
                    <ng-container
                      *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['sp', 'lf', 'st', 'rep'] }">
                      {{ column.id | titlecase | mrTranslate }}
                    </ng-container>
                  </clr-dg-column>
                }
                <clr-dg-row *clrDgItems="let row of objekttabelle.rows" [clrDgItem]="row">
                  <!-- [clrDgSelectable]="obegpid != 0"> -->
                  @for (cell of objekttabelle.columns; track cell) {
                    <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                  }
                </clr-dg-row>
                <clr-dg-footer>{{ objekttabelle.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
              </clr-datagrid>
            }
          </div>
        </div>
        <div class="clr-col-md-6">
          <div class="clr-row nxm" style="padding-right: 10px">
            <div class="clr-col-md-11">
              <h4 style="margin-top: 2px">{{ 'Mängel' | mrTranslate }}</h4>
            </div>
            <div class="clr-col-md-1">
              <div class="btn-group btn-primary btn-icon">
                <button
                  class="btn btn-icon"
                  [title]="'Neuen Mangel hinzufügen' | mrTranslate"
                  (click)="addMangel()"
                  [disabled]="lpid == 0"
                  style="margin-top: -10px">
                  <cds-icon shape="plus-circle" />
                </button>
              </div>
            </div>
          </div>
          <div class="limit-height">
            @if (selectedMaengel?.columns?.length > 0) {
              <clr-datagrid style="margin-top: -3px" #objekteGrid class="datagrid-compact">
                @for (column of selectedMaengel.columns; track column) {
                  <clr-dg-column [clrDgField]="column.id">
                    <ng-container
                      *clrDgHideableColumn="{
                        hidden:
                          column.id
                          | hideIDColumns: ['icon', 'sperrstatus', 'lfstatus', 'anlagenobjekte', 'pruefdatum'],
                      }">
                      {{ column.id | titlecase | mrUnitText }}
                    </ng-container>
                  </clr-dg-column>
                }
                <clr-dg-row *clrDgItems="let row of selectedMaengel.rows" [clrDgItem]="row">
                  @for (cell of selectedMaengel.columns; track cell) {
                    <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                  }
                </clr-dg-row>
                <clr-dg-footer>{{ selectedMaengel.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
              </clr-datagrid>
            }
          </div>
        </div>
      </div>
    }
    @if (completedobjekttabelle?.rows?.length > 0) {
      <div class="clr-row nxm" style="padding-right: 10px">
        <div class="clr-col-md-6">
          <div class="clr-row nxm" style="padding-right: 10px">
            <h4 style="margin-top: 15px">{{ 'Begehung abgeschlossen' | mrTranslate }}</h4>
          </div>
        </div>
        <div class="clr-col-md-6">
          <div class="clr-row nxm" style="padding-right: 10px">
            <div class="clr-col-md-11"></div>
            <div class="clr-col-md-1">
              <div class="btn-group btn-primary btn-icon" style="margin-top: 10px">
                <button
                  class="btn btn-icon btn-danger"
                  [title]="'Objekt wieder aktivieren' | mrTranslate"
                  (click)="reaktivBegehungObjekt()"
                  [disabled]="ostammidFinished == 0">
                  <cds-icon shape="times" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clr-row nxm" style="padding-right: 10px">
        <div class="clr-col-md-12">
          <clr-datagrid
            #objekteDatagrid
            class="datagrid-compact dg-overflow-fix"
            [clrDgSelectionType]="'single'"
            [clrDgSelected]="[selectedFinishedObjekt]"
            (clrDgSelectedChange)="selectedFinishedObjekt = $event[0]; selectionFinishedObjektChanged($event[0])"
            [clrDgRowSelection]="true">
            @for (column of completedobjekttabelle.columns; track column) {
              <clr-dg-column [clrDgField]="column.id" [style.min-width.px]="column.id.length * 7.5 + 26">
                <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['sp', 'lf', 'st', 'rep'] }">
                  {{ column.id | titlecase | mrTranslate }}
                </ng-container>
              </clr-dg-column>
            }
            <clr-dg-row *clrDgItems="let row of completedobjekttabelle.rows" [clrDgItem]="row">
              @for (cell of completedobjekttabelle.columns; track cell) {
                <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
              }
            </clr-dg-row>
            <clr-dg-footer>{{ completedobjekttabelle.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        </div>
      </div>
    }
  </div>
</div>

